import { DIC } from "@/const/dic";
import { formatterTime } from "@/util/util";
import { baseUrl } from "@/config/env";
export const goodsQrOption = {
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  // align: 'center',
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  menuWidth: "300",
  labelWidth: "160",
  // menuType:'menu',
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "二维码编号",
      prop: "number",
      search: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "二维码名称",
      prop: "name",
      type: "input",
      rules: [
        {
          required: true,
          message: "请输入二维码名称",
          trigger: "blur",
        },
      ],
    },
    {
      label: "店铺",
      prop: "shopName",
      formsolt: true,
      search: true,
      // hide: true,
      rules: [
        {
          required: true,
          trigger: "change",
          message: "请选择店铺",
        },
      ],
    },
    {
      label: "商品品牌",
      prop: "brandName",
      formsolt: true,
      rules: [
        {
          required: true,
          trigger: "change",
          message: "请选择商品品牌",
        },
      ],
    },
    {
      label: "是否全分类",
      prop: "fullClassification",
      type: "select",
      dicData: DIC.YES_NO,
      hide: true,
      formsolt: true,
    },
    {
      label: "商品一级分类",
      prop: "firstClassifyName",
      formsolt: true,
      rules: [
        {
          required: true,
          trigger: "change",
          message: "请选择商品一级分类",
        },
      ],
    },
    {
      label: "商品二级分类",
      prop: "secondClassifyName",
      formsolt: true,
    },
    {
      label: "商品",
      prop: "goodsName",
      formsolt: true,
    },
    {
      label: "生成商品码数量",
      prop: "num",
      type: "input",
      rules: [
        {
          required: true,
          message: "请输入生成商品码数量",
          trigger: "blur",
        },
      ],
    },
    {
      label: "推广费",
      prop: "promotionCost",
      type: "input",
      rules: [
        {
          required: true,
          message: "请输入推广费",
          trigger: "blur",
        },
      ],
    },
    // 推广积分
    {
      label: "推广积分",
      prop: "integral",
      type: "input",
      rules: [
        {
          required: true,
          message: "请输入推广积分",
          trigger: "blur",
        },
      ],
    },
    {
      label: "有效期",
      prop: "startDate_endDate",
      type: "datetimerange",
      valueFormat: "timestamp",
      span: 12,
      clearable: true,
      addVisdiplay: false,
      formatter: function (row) {
        return formatterTime(row.startTime) + "至" + formatterTime(row.endTime);
      },
    },
    // 创建时间
    {
      label: "创建时间",
      prop: "createTime",
      type: "datetime",
      valueFormat: "timestamp",
      span: 12,
      clearable: true,
      addVisdiplay: false,
      editVisdiplay: false,
      formatter: function (row) {
        return formatterTime(row.createTime);
      },
    },
    // 开始时间
    {
      label: "开始时间",
      prop: "startTime",
      type: "datetime",
      valueFormat: "timestamp",
      hide: true,
      span: 12,
      // clearable:true,
      rules: [
        {
          required: true,
          message: "请选择开始时间",
          trigger: "change",
        },
      ],
    },
    {
      label: "结束时间",
      prop: "endTime",
      hide: true,
      type: "datetime",
      valueFormat: "timestamp",
      span: 12,
      // clearable:true,
      rules: [
        {
          required: true,
          message: "请选择结束时间",
          trigger: "change",
        },
      ],
    },
    {
      label: "类型名称",
      prop: "typeName",
      type: "input",
      rules: [
        {
          required: true,
          message: "请输入类型名称",
          trigger: "blur",
        },
      ],
    },
    // 支付状态
    {
      label: "支付状态",
      solt: true,
      prop: "payStatus",
      type: "select",
      dicData: DIC.PAY_STATUS,
      addVisdiplay: false,
      editVisdiplay: false,
    },
  ],
};
